import { UnifiedGraftModelTypeKey } from './unifiedGraftModelTypeKeys.const'

/** Member type keys in TYPE_DEF (excludes GENERIC_PARAMETERS, etc.). Uses enum key strings. */
export const MEMBER_IDS = [
  UnifiedGraftModelTypeKey.TYPE_DEF,
  UnifiedGraftModelTypeKey.CONSTRUCTOR,
  UnifiedGraftModelTypeKey.OVERLOADED_CONSTRUCTOR,
  UnifiedGraftModelTypeKey.INSTANCE_FIELD,
  UnifiedGraftModelTypeKey.STATIC_FIELD,
  UnifiedGraftModelTypeKey.INSTANCE_METHOD,
  UnifiedGraftModelTypeKey.STATIC_METHOD,
  UnifiedGraftModelTypeKey.OVERLOADED_INSTANCE_METHOD,
  UnifiedGraftModelTypeKey.OVERLOADED_STATIC_METHOD,
  UnifiedGraftModelTypeKey.PROPERTY,
] as const
